import { Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Notify } from "@/components/ui/notify";
import type { IndicatorDefinitionResponse } from "@/types/indicators.types";

interface IndicatorListProps {
  items: IndicatorDefinitionResponse[];
  canEdit: boolean;
  onEdit: (item: IndicatorDefinitionResponse) => void;
  onDelete: (item: IndicatorDefinitionResponse) => void;
  onNew: () => void;
}

export function IndicatorList({ items, canEdit, onEdit, onDelete, onNew }: IndicatorListProps) {
  if (items.length === 0) {
    return (
      <Notify.Empty
        title="Nenhum indicador próprio"
        description="Um indicador é montado por frases: a linha produz, consome ou refuga um produto. O aproveitamento da fábrica é um caso dele."
        action={
          canEdit ? (
            <Button size="sm" onClick={onNew}>
              Criar indicador
            </Button>
          ) : undefined
        }
      />
    );
  }

  return (
    <ul className="divide-y divide-border-default rounded-md border border-border-default">
      {items.map((i) => (
        <li key={i.id} className="flex flex-wrap items-center justify-between gap-2 px-3 py-2">
          <div className="min-w-0">
            <div className="text-[14px] font-medium text-text-primary">{i.name}</div>
            <div className="text-[12px] text-text-secondary">
              {i.terms.filter((t) => t.side === "NUMERATOR").length} frase(s) no numerador ·{" "}
              {i.terms.filter((t) => t.side === "DENOMINATOR").length} no denominador · base{" "}
              {i.baseUnit}
              {i.target !== null ? ` · meta ${i.target.toLocaleString("pt-BR")}%` : ""}
            </div>
          </div>
          {canEdit ? (
            <div className="flex gap-1.5">
              <Button
                variant="outline"
                size="sm"
                aria-label={`Editar ${i.name}`}
                onClick={() => onEdit(i)}
              >
                <Pencil size={14} />
              </Button>
              <Button
                variant="outline"
                size="sm"
                aria-label={`Apagar ${i.name}`}
                onClick={() => onDelete(i)}
              >
                <Trash2 size={14} />
              </Button>
            </div>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
